import { createContext, useContext, type ReactNode } from 'react'
import type { ToastType } from './Toast'

export type AppToast = {
    id: string
    type: ToastType['type']
    message: ReactNode
    durationMs?: number
    remainingMs: number
    lastStartedAt?: number
    isClosing?: boolean
}

export type NewToast = {
    type: ToastType['type']
    message: ReactNode
    durationMs?: number
}

export type ToastContextValue = {
    toasts: AppToast[]
    showToast: (toast: NewToast) => void
    removeToast: (toastId: string) => void
    pauseToasts: () => void
    resumeToasts: () => void
}

export const ToastContext = createContext<ToastContextValue | null>(null)

export const useToast = () => {
    const context = useContext(ToastContext)

    if (!context) {
        throw new Error('useToast must be used within ToastProvider')
    }

    return context
}

export const useOptionalToast = () => useContext(ToastContext)
